export interface ClientDatabase {
    clientID: number;
    group: string;
    groupDescription: string;
    databaseName: string;
    serverName: string;
    isLocked: boolean;
}

export const DatabaseEnvironments = [{ label: "Prod to Dev", value: 1}, {label: "Prod to Test", value: 2}]